var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3571 15.112H9.14864M1 15.5L5.30656 13.8436C5.58201 13.7377 5.71974 13.6847 5.8486 13.6155C5.96305 13.5541 6.07216 13.4832 6.17479 13.4036C6.29033 13.3139 6.39468 13.2096 6.60336 13.0009L15.3571 4.24715C16.2143 3.38993 16.2143 2.00012 15.3571 1.14291C14.4999 0.285698 13.1101 0.285697 12.2529 1.14291L3.49913 9.89664C3.29044 10.1053 3.1861 10.2097 3.09644 10.3252C3.0168 10.4278 2.94589 10.5369 2.88445 10.6514C2.81528 10.7803 2.76231 10.918 2.65637 11.1934L1 15.5ZM1 15.5L2.59722 11.3473C2.71152 11.0501 2.76867 10.9015 2.86669 10.8335C2.95235 10.774 3.05834 10.7515 3.16078 10.7711C3.27799 10.7934 3.39056 10.906 3.61569 11.1311L5.36888 12.8843C5.59401 13.1095 5.70658 13.222 5.72897 13.3392C5.74853 13.4417 5.72603 13.5477 5.66655 13.6333C5.5985 13.7314 5.44991 13.7885 5.15275 13.9028L1 15.5Z",
    stroke: "#017F3B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.d7fbcc2fe478bac79cc4de3dfcc07d47.svg";
export { ForwardRef as ReactComponent };